import { useMemo, useEffect, useRef } from 'react'

import useReducers from '@/store/long-creation'

export default function useCheckLongCreationPending(type, interval = 2000) {
  const [state, actions] = useReducers()
  const unmounted = useRef(false)
  const timer = useRef()

  const messages = useMemo(() => {
    return state.messages[state.active] || []
  }, [state.messages, state.active])

  const hasPending = useMemo(() => {
    return messages.some(item => item.type === type && item.role === 'assistant' && item.status === 'PENDING')
  }, [messages, type])

  useEffect(() => {
    return () => {
      unmounted.current = true
    }
  }, [])

  useEffect(() => {
    if (!hasPending) {
      clearInterval(timer.current)
      return
    }

    timer.current = setInterval(() => {
      if (!unmounted.current) {
        actions.getChatMessages(state.active)
      }
    }, interval)

    return () => {
      clearInterval(timer.current)
    }
  }, [state.active, hasPending, interval])
}
